/* eslint-disable tailwindcss/no-arbitrary-value */
import React, { useEffect } from 'react';
import { string } from 'prop-types';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { Price } from '@thd-olt-component-react/price';
import { Typography } from '@one-thd/sui-atomic-components';
import logNewRelicCustom from '../../utils/logNewRelicCustom';
import { usePromoStore } from '../../store';
import { NEW_RELIC_EVENTS } from '../../constants';

const TotalPrice = ({ itemId, text = 'Total Price' }) => {
  const totalPriceData = usePromoStore((state) => state.totalPrice);
  const {
    originalPrice,
    dollarOff,
    percentOff,
    value
  } = totalPriceData;

  useEffect(() => {
    logNewRelicCustom(NEW_RELIC_EVENTS.TOTAL_PRICE, { totalPrice: totalPriceData });

    return () => false;
  }, [totalPriceData]);

  return (
    <ErrorBoundary name="eb-total-price-desktop">
      <div className="sui-flex sui-w-full sui-justify-end sui-pt-3 sui-pl-4">

        <Typography variant="h4">{text}:</Typography>

        <div className="lg:sui-mt-[3px] sui-mt-[1px] sui-text-[1.3rem] custom-price">
          <QueryProvider
            dataSource="catalog"
            cacheKey="total-price-desktop"
          >
            <Price
              itemId={itemId}
              skip
              channel="mobile"
              large={false}
              hideLimitPerOrder
              displayEachUom={false}
              disableOuterSpacing={false}
              clsRemediation={{
                placeholders: true,
                preservePlaceholders: true
              }}
              product={
                {
                  pricing: {
                    alternatePriceDisplay: false,
                    conditionalPromotions: null,
                    mapAboveOriginalPrice: null,
                    message: null,
                    original: originalPrice,
                    preferredPriceFlag: false,
                    promotion: {
                      dollarOff,
                      percentageOff: percentOff,
                    },
                    specialBuy: null,
                    unitOfMeasure: 'each',
                    value,
                  }
                }
              }
            />
          </QueryProvider>
        </div>
      </div>
    </ErrorBoundary>
  );
};

TotalPrice.propTypes = {
  itemId: string.isRequired,
  text: string.isRequired,
};

export default TotalPrice;